export default {
      id: "facebook-usage",
      viewBox: "0 0 14 24",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#facebook",
      toString: function () {
        return this.url;
      }
    }